<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <b-row class="h-5">
        <b-col cols="12">
          <S040000Menu
            :t="t"
            :dictEnum="dictEnum"
            :isLeaveRecordVisible="
              hasRight('AlwRead', Settings.MenuID.StaffLeaveRecord)
            "
            :isStaffAttendanceVisible="
              hasRight('AlwRead', Settings.MenuID.StaffAttendance)
            "
            :isMonthlyVisible="
              hasRight('AlwRead', Settings.MenuID.MonthlyLeaveBalance)
            "
            :isOutdoorVisible="
              hasRight('AlwRead', Settings.MenuID.OutdoorWorkAllowance)
            "
            :isTaxReturnVisible="hasRight('AlwRead', Settings.MenuID.TaxReturn)"
          />
        </b-col>
      </b-row>

      <b-row class="h-10" align-v="center">
        <b-col cols="1">
          <b-form-select v-model="rptType">
            <!-- <option value="All" selected="selected">
              {{ t.t(dictEnum.LBL_SelectAll) }}
            </option> -->
            <option
              v-for="(type, typeIndex) in rptTypeList"
              :key="typeIndex"
              :value="type.id"
            >
              {{ type.value }}
            </option>
          </b-form-select>
        </b-col>
        <b-col cols="2">
          <date-picker
            id="dpMonth"
            :placeholder="this.t.t(dictEnum.LBL_Month)"
            v-model="month"
            :lang="lang"
            type="month"
            format="MM/YYYY"
            v-bind:editable="false"
            v-bind:clearable="false"
            @change="getStaffList()"
          ></date-picker>
        </b-col>
        <b-col cols="2">
          <b-form-select size="sm" v-model="selectedComp" @change="changeComp">
            <option value selected>
              --- {{ this.t.t(dictEnum.LBL_Company) }} ---
            </option>
            <option
              v-for="(comp, index) in compList"
              :key="index"
              :value="comp.CompCode"
            >
              {{ user.Lang == "EN" ? comp.EName : comp.CName }}
            </option>
          </b-form-select>
        </b-col>
        <b-col cols="2">
          <div class="d-flex align-items-center input-mb-0">
            <v-text-field
              :readonly="true"
              style="margin-top: -12px"
              class="form-input"
              name="staff"
              v-validate="{
                required: true
              }"
              :placeholder="'--- ' + this.t.t(dictEnum.LBL_Staff) + ' ---'"
              v-model="selectedStaff"
            ></v-text-field>
            <button
              type="button"
              class="btn btn-transparent p-1"
              :disabled="false"
              v-on:click="OnStaffBtnClick()"
            >
              <img src="../../../static/images/search.png" class="w-14" />
            </button>
          </div>
        </b-col>

        <b-col cols="5" align-self="center" class="text-right">
          <button class="btn btn-info" @click="search">
            {{ this.t.t(dictEnum.LBL_Filter) }}
          </button>

          <download-excel
            v-if="hasRight('AlwExp', Settings.MenuID.TaxReturn)"
            class="btn btn-primary"
            :fetch="ExportTableData"
            :fields="columnsexport"
            type="xls"
            name="taxReturn.xls"
            :meta="[{ key: 'charset', value: 'utf-8' }]"
            >{{ this.t.t(dictEnum.BTN_Export) + "Excel" }}</download-excel
          >

          <!-- <download-excel
            v-if="hasRight('AlwExp', Settings.MenuID.TaxReturn)"
            class="btn btn-primary"
            :fetch="ExportXMLTableData"
            :fields="columnsexport"
            type="xml"
            name="taxReturn.xml"
            :meta="[{ key: 'charset', value: 'utf-8' }]"
            >{{ this.t.t(dictEnum.BTN_Export) }}</download-excel
          > -->

          <button
            v-if="hasRight('AlwExp', Settings.MenuID.TaxReturn)"
            class="btn btn-primary"
            @click="ExportPdf"
          >
            {{ this.t.t(dictEnum.BTN_Export) + "Pdf" }}
          </button>
          <button
            v-if="hasRight('AlwExp', Settings.MenuID.TaxReturn)"
            class="btn btn-primary"
            @click="ExportXML"
          >
            {{ this.t.t(dictEnum.BTN_Export) + "XML" }}
          </button>
        </b-col>
      </b-row>

      <b-row class="h-80">
        <b-col cols="12">
          <div class="tab-content bg-white h-100">
            <div class="tab-pane active table-responsive color-table h-85">
              <b-table
                :items="tableData"
                :fields="fields"
                :current-page="currentPage"
                :per-page="15"
                @row-clicked="onRowClick"
                selectable
                select-mode="single"
              >
                <template #head(Staff)="data">
                  <b-th sticky-column>{{
                    JSON.parse(JSON.stringify(data))["label"]
                  }}</b-th>
                </template>
                <template #head(EmployeeFile)="data">
                  <b-th sticky-column>{{
                    JSON.parse(JSON.stringify(data))["label"]
                  }}</b-th>
                </template>
                <template #head(CName)="data">
                  <b-th sticky-column>{{
                    JSON.parse(JSON.stringify(data))["label"]
                  }}</b-th>
                </template>
                <template #cell(Salary)="data">
                  <b-td>{{ parseFloat(data.item.Salary).toFixed(2) }}</b-td>
                </template>
                <template #cell(ChiName)="data">
                  <b-td>
                    {{ `${data.item.ChiLastName}${data.item.ChiName}` }}</b-td
                  >
                </template>
                <template #cell(EngName)="data">
                  <b-td>
                    {{ `${data.item.EngName} ${data.item.EngLastName}` }}</b-td
                  >
                </template>
              </b-table>
            </div>
            <b-row no-gutters class="pt-3" v-if="tableData.length > 0">
              <b-col cols="2">
                <b-pagination
                  first-number
                  last-number
                  limit="10"
                  v-model="currentPage"
                  :per-page="15"
                  :total-rows="total"
                  @change="changePage"
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Staff  Modal Start -->
    <div
      class="modal fade"
      id="staffModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="staffModel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered mw-820" role="document">
        <div class="modal-content list-modal">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              {{ t.t(dictEnum.LBL_StaffList) }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-search">
            <form class="form-inline">
              <div class="form-group mx-sm-3 mb-2 mt-2">
                <label for="inputPassword2" class="sr-only">search</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputPassword2"
                  v-model="searchValue"
                  :placeholder="t.t(dictEnum.LBL_SearchStaff)"
                />
              </div>
              <button
                type="button"
                class="btn btn-info ml-2"
                @click="OnStaffSelect"
              >
                {{ this.t.t(dictEnum.BTN_Save) }}
              </button>
            </form>
          </div>
          <div class="modal-body p-0">
            <v-simple-table
              class="table table-sm mb-0 modal-tbl"
              min-height="500"
              height="500"
            >
              <template>
                <thead>
                  <tr>
                    <th width="2%">
                      <input type="checkbox" v-model="allChecked" />
                    </th>
                    <th width="15%">
                      {{ t.t(dictEnum.LBL_StaffID) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_UserChiname) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_EngName) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_Job) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in StaffList"
                    :key="StaffList.StaffID"
                    @click.stop="selectStaff(item.StaffID)"
                  >
                    <td width="2%">
                      <input type="checkbox" v-model="item.isChecked" />
                    </td>
                    <td width="15%">{{ item.StaffID }}</td>
                    <td width="20%">
                      {{ `${item.ChiLastName}${item.ChiName}` }}
                    </td>
                    <td width="20%">
                      {{ `${item.EngName} ${item.EngLastName}` }}
                    </td>
                    <td width="20%">
                      {{ `${item.JobTitle}` }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </div>
    </div>
    <!-- Staff Modal End -->
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import ReportService from "@/service/ReportService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import S040000Menu from "@/components/S040000-Report/S040000-Menu.vue";
import SweetAlertService from "@/service/SweetAlertService";
import { datePickerLang } from "@/constants/globalConstants";
import Settings from "../../constants/Settings";
import StaffService from "../../service/StaffService";
import ArrayHelper from "../../common/helper/ArrayHelper";

export default {
  components: {
    DatePicker,
    moment,
    S040000Menu
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      Settings: Settings,
      menuId: Settings.MenuID.TaxReturn,
      staffList: [],
      searchValue: "",
      selectedStaff: "", // 员工输入框字段
      selectedStaffList: [], // 选中的所有员工
      selectedUserID: [],
      selectedRowStaff: "",
      dictEnum: dictEnum,

      columnsexport: {
        Staff: "StaffID",
        EmployeeFile: "EmpFileNum",
        CName: "ChiName",
        EName: "EngName",
        Employer: "EmplyrName",
        HKID: "DocNum",
        Sex: "Gender",
        MaritalStatus: "MaritalStatus",
        EmploymentPeriod: "EmpPeriod",
        Salary: "Salary",
        LeavePay: "LeavePay"
      },
      tableData: [],
      xmlTableData: [],

      month: moment()
        .startOf("month")
        .format(Settings.DateTime.yyyymmdd),
      // custom lang
      lang: datePickerLang,
      currentPage: 1,
      fields: [
        {
          key: "StaffID",
          label: t.t(dictEnum.LBL_Staff)
        },
        {
          key: "EmpFileNum",
          label: t.t(dictEnum.LBL_EmployeeFile)
        },
        {
          key: "ChiName",
          label: t.t(dictEnum.LBL_CName)
        },
        {
          key: "EngName",
          label: t.t(dictEnum.LBL_EName)
        },
        // {
        //   key: "EmplyrName",
        //   label: t.t(dictEnum.LBL_Employer)
        // },
        {
          key: "DocNum",
          label: t.t(dictEnum.LBL_HKID)
        },
        {
          key: "Gender",
          label: t.t(dictEnum.LBL_Sex)
        },
        {
          key: "MaritalStatus",
          label: t.t(dictEnum.LBL_MaritalStatus)
        },
        {
          key: "EmpPeriod",
          label: t.t(dictEnum.LBL_EmploymentPeriod)
        },
        {
          key: "Salary",
          label: t.t(dictEnum.LBL_Salary)
        },
        {
          key: "LeavePay",
          label: t.t(dictEnum.LBL_LeavePay)
        }
      ],
      compList: [],
      selectedComp: "",
      total: 0,
      rptType: 0,
      rptTypeList: [
        { id: 0, value: "56B" },
        { id: 1, value: "56E" },
        { id: 2, value: "56F" },
        { id: 3, value: "56G" },
        { id: 4, value: "56M" },
        { id: 5, value: "56M2" }
      ]
    };
  },
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    userName() {
      return this.$store.getters[StoreGetter.user].Lang == "EN"
        ? this.$store.getters[StoreGetter.user].EngName
        : this.$store.getters[StoreGetter.user].ChiName;
    },
    StaffList() {
      let list = this.staffList;
      if (this.selectedComp) {
        list = list.filter(x => x.CompCode == this.selectedComp);
      }
      if (this.searchValue != "") {
        list = list.filter(x =>
          ArrayHelper.staffSearch(x, this.searchValue.toLowerCase())
        );
      }
      return list;
    },
    allChecked: {
      get() {
        return this.StaffList.every(staff => staff.isChecked);
      },
      set(value) {
        this.StaffList.forEach(staff => {
          this.$set(staff, "isChecked", value);
        });
        console.log("this.StaffList", this.StaffList, value);
      }
    }
  },
  methods: {
    hasRight(key) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          this.menuId,
          key
        );
      }
    },

    assignRights() {
      this.menuRights.allRights = this.menuRights.allRights = this.$store.getters[
        StoreGetter.sysMenu
      ];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },

    changeComp() {
      this.selectedStaff = "";
      this.selectedStaffList = [];
      this.selectedUserID = [];
      this.selectedRowStaff = "";
    },

    OnStaffBtnClick: function() {
      $("#staffModel").modal("show");
    },
    OnStaffSelect: function() {
      var self = this;
      self.selectedStaff = "";
      self.selectedStaffList = [];
      self.StaffList.forEach(staff => {
        if (staff.isChecked) {
          self.selectedStaffList.push(staff);
        }
      });
      if (self.$store.getters[StoreGetter.user].Lang == "EN") {
        self.selectedStaff = self.selectedStaffList
          .map(selStf => selStf["EngName"] + " " + selStf["EngLastName"])
          .join(",");
      } else {
        self.selectedStaff = self.selectedStaffList
          .map(selStf => selStf["ChiLastName"] + " " + selStf["ChiName"])
          .join(",");
      }
      self.selectedUserID = self.selectedStaffList.map(
        selStf => selStf["StaffID"]
      );
      $("#staffModel").modal("hide");
    },

    selectStaff: function(staffID) {
      let whereIndex = this.staffList.findIndex(staffItem => {
        return staffItem.StaffID == staffID;
      });
      if (whereIndex !== -1) {
        let bool = !this.staffList[whereIndex]["isChecked"];
        this.$set(this.staffList[whereIndex], "isChecked", bool);
      }
    },
    onRowClick: function(row) {
      this.selectedRowStaff = row.StaffID;
    },

    async changePage(e) {
      const obj = {
        staff: this.selectedUserID,
        fiscalYear: new Date(
          moment(this.month)
            .startOf("month")
            .format(Settings.DateTime.yyyy)
        ).getFullYear(),
        take: 15,
        skip: (e - 1) * 15
      };

      const response = await ReportService.IRDList(obj);
      if (response.data.IsSuccess) {
        let data = response.data.Data.Item1;
        this.total = response.data.Data.Item2;
        const staffItemList = new Array(this.total);
        staffItemList.splice((e - 1) * 15, data.length, ...data);
        this.tableData = staffItemList;
        this.xmlTableData = staffItemList.filter(
          item => typeof item !== "undefined"
        );
      } else {
        SweetAlertService.error("Error", response.data.Message);
      }
    },
    async search() {
      this.selectedRowStaff = "";
      if (this.selectedStaff == "") {
        // SweetAlertService.error(
        //   "Error",
        //   this.t.t(dictEnum.LBL_Staff) + this.t.t(dictEnum.WARN_IsRequired)
        // );
        // return;
        this.allChecked = true;
        this.OnStaffSelect();
      }

      if (this.month == "") {
        SweetAlertService.error(
          "Error",
          this.t.t(dictEnum.LBL_Month) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      console.log("this.currentPage", this.currentPage);
      const obj = {
        staff: this.selectedUserID,
        fiscalYear: new Date(
          moment(this.month)
            .startOf("month")
            .format(Settings.DateTime.yyyy)
        ).getFullYear(),
        compCode: this.selectedComp,
        rptType: this.rptType,
        take: 15,
        skip: (this.currentPage - 1) * 15
      };

      const response = await ReportService.IRDList(obj);
      if (response.data.IsSuccess) {
        let data = response.data.Data.Item1;
        this.total = response.data.Data.Item2;
        const staffItemList = new Array(this.total);
        staffItemList.splice((this.currentPage - 1) * 15, data.length, ...data);
        this.tableData = staffItemList;
        this.xmlTableData = staffItemList.filter(
          item => typeof item !== "undefined"
        );
      } else {
        SweetAlertService.error("Error", response.data.Message);
      }
    },

    async ExportTableData() {
      this.selectedRowStaff = "";
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_ExportFile),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        return this.tableData;
      }
    },
    async ExportPdf() {
      if (this.rptType == 5) {
        if (this.selectedUserID.length == 0) {
          SweetAlertService.warning(
            "Warn",
            this.t.t(dictEnum.WARN_SelectOneRecord)
          );
        } else {
          const obj = {
            staff: this.selectedUserID,
            fiscalYear: new Date(
              moment(this.month)
                .startOf("month")
                .format(Settings.DateTime.yyyy)
            ).getFullYear(),
            rptType: this.rptType,
            compCode: this.selectedComp
          };
          const response = await ReportService.printIR56M2(obj);
          if (response.data.IsSuccess) {
            window.open(response.data.Data, "_blank");
          } else {
            SweetAlertService.warning("Warn", response.data.Message);
          }
        }
      } else {
        if (this.selectedRowStaff != "") {
          const obj = {
            staffID: this.selectedRowStaff,
            fiscalYear: new Date(
              moment(this.month)
                .startOf("month")
                .format(Settings.DateTime.yyyy)
            ).getFullYear(),
            rptType: this.rptType,
            compCode: this.selectedComp
          };
          const response = await ReportService.printIRD(obj);
          if (response.data.IsSuccess) {
            window.open(response.data.Data, "_blank");
          } else {
            SweetAlertService.warning("Warn", response.data.Message);
          }
        } else {
          SweetAlertService.warning(
            "Warn",
            this.t.t(dictEnum.WARN_SelectOneRecord)
          );
        }
      }
    },
    async ExportXML() {
      this.selectedRowStaff = "";
      const obj = {
        staff: this.selectedUserID,
        fiscalYear: new Date(
          moment(this.month)
            .startOf("month")
            .format(Settings.DateTime.yyyy)
        ).getFullYear(),
        rptType: this.rptType,
        compCode: this.selectedComp
      };
      const response = await ReportService.expToXml(obj);
      if (response) {
        console.log("result", response);

        var blob = new Blob([response.data], {
          type: "application/xml;charset=utf-8"
        });
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(blob, "Print.xml");
        //   return;
        // }
        let url = window.URL.createObjectURL(blob);
        let aTag = document.createElement("a");
        aTag.href = url;
        aTag.download = "Print.xml";
        aTag.click();
        aTag = null;
        // var win = window.open(url, "_blank");
        // if (!win || win.closed || typeof win.closed == "undefined") {
        //   SweetAlertService.error("Error", response.data.Message);
        // } else {
        //   win.print();
        // }
      }
    },

    async getCompanyList() {
      const obj = {};
      const response = await StaffService.getAllCompany(obj);
      if (response.data.IsSuccess) {
        this.compList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getStaffList() {
      const obj = {
        staffID: this.user.UserID,
        dateFrom: moment(this.month)
          .startOf("month")
          .format(Settings.DateTime.yyyymmdd),
        dateTo: moment(this.month)
          .endOf("month")
          .format(Settings.DateTime.yyyymmdd)
      };
      const response = await StaffService.getStaffListOnDuty(obj);
      if (response.data.IsSuccess) {
        this.staffList = response.data.Data;
        this.StaffList.forEach(staff => {
          this.$set(staff, "isChecked", false);
        });
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getdatatable() {
      const date = moment(this.month)
        .startOf("month")
        .format(Settings.DateTime.yyyymmdd);
      const obj = {
        userId: this.$store.getters[StoreGetter.user].UserId,
        date: date
      };

      const response = await ReportService.getStaffOutdoorworkAllowance(obj);
      if (response.data.IsSuccess) {
        this.tableData = response.data.Data;
      } else {
        SweetAlertService.error("Error", response.data.Message);
      }
    }
  },
  mounted() {
    this.assignRights();
    //this.getdatatable();
    this.getStaffList();
    this.getCompanyList();
  }
};
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  min-height: 158px !important;
}
.mx-calendar-icon {
  width: 100%;
  height: auto !important;
  color: #555;
  stroke-width: 8px;
  stroke: currentColor;
  fill: currentColor;
}

.table-lateIn {
  height: 100%;
  background-color: #e6bfd6;
}
.table-leaveEarly {
  height: 100%;
  background-color: #d0eef8;
}
</style>



// WEBPACK FOOTER //
// src/components/S040000-Report/S040500-TaxReturn.vue